import { render, staticRenderFns } from "./ModelsAssigned.vue?vue&type=template&id=700dadb2&"
import script from "./ModelsAssigned.vue?vue&type=script&lang=js&"
export * from "./ModelsAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports